module.exports = __webpack_public_path__ + "img/9788930317191.c8d90492.jpg";